import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Wallet, FileCheck } from "lucide-react";
import {
  imgFrame234,
  imgNbaLogo,
  imgPartner2,
  imgPartner3,
  imgPartner5,
  imgPartner6,
} from "../../assets";

export default function About() {
  return (
    <div className="bg-white w-full">
      <div className="container mx-auto px-4 py-20 md:py-32">
        {/* Header Section */}
        <div className="mb-24 relative">
          {/* Header Label */}
          <h4 className="text-base font-bold mb-12">About Us</h4>

          <div className="flex flex-col items-center text-center max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold mb-8 text-black">
              The NBA Remuneration Portal
            </h1>

            <p className="text-base text-gray-800 leading-relaxed mb-16 max-w-3xl">
              The Nigerian Bar Association, through its Lagos State branches,
              has established this Digital Compliance Portal to protect your
              professional fees and streamline property transaction management.
              The platform ensures systematic compliance with the Legal
              Practitioners Remuneration Order while providing modern tools for
              efficient practice management across all six NBA branches in Lagos
              State.
            </p>

            {/* Partners Inline */}
            <div className="flex flex-col items-center mb-16 w-full">
              <h3 className="text-sm font-semibold text-gray-900 mb-8 uppercase tracking-wider">
                Our Trusted Partners
              </h3>
              <div className="flex flex-wrap justify-center items-center gap-12 grayscale opacity-100">
                <img
                  src={imgNbaLogo}
                  alt="NBA"
                  className="h-16 object-contain"
                />
                <img
                  src={imgPartner2}
                  alt="Klasha"
                  className="h-6 object-contain"
                />
                <img
                  src={imgPartner3}
                  alt="Sudo"
                  className="h-5 object-contain"
                />
                <img
                  src={imgPartner5}
                  alt="Squad"
                  className="h-6 object-contain"
                />
                <img
                  src={imgPartner6}
                  alt="Kuda"
                  className="h-5 object-contain"
                />
              </div>
            </div>

            {/* Hero Image */}
            <div className="w-full h-[500px] rounded-3xl overflow-hidden shadow-xl mb-24">
              <img
                src={imgFrame234}
                alt="Lagos Skyline"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Core Value Section */}
        <div className="mb-32">
          <h2 className="text-3xl font-bold mb-16 text-black">Core Value</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {/* Card 1 */}
            <div className="bg-white p-10 rounded-[32px] shadow-sm border border-gray-100 flex flex-col items-start  hover:shadow-md transition-shadow">
              <div className="w-16 h-16 rounded-full bg-[#E8F5E9] flex items-center justify-center text-[var(--nba-green)] mb-8">
                <FileCheck size={32} />
              </div>
              <h3 className="text-xl font-bold mb-4 text-black">
                Digital Compliance
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Centralised verification and secure record keeping for all
                property documents.
              </p>
            </div>

            {/* Card 2 */}
            <div className="bg-white p-10 rounded-[32px] shadow-sm border border-gray-100 flex flex-col items-start hover:shadow-md transition-shadow">
              <div className="w-16 h-16 rounded-full bg-[#E8F5E9] flex items-center justify-center text-[var(--nba-green)] mb-8">
                <ShieldCheck size={32} />
              </div>
              <h3 className="text-xl font-bold mb-4 text-black">
                Fee Compliance
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Automatic application of NBA-approved fees preventing
                undercutting while allowing premium rates.
              </p>
            </div>

            {/* Card 3 */}
            <div className="bg-white p-10 rounded-[32px] shadow-sm border border-gray-100 flex flex-col items-start hover:shadow-md transition-shadow">
              <div className="w-16 h-16 rounded-full bg-[#E8F5E9] flex items-center justify-center text-[var(--nba-green)] mb-8">
                <Wallet size={32} />
              </div>
              <h3 className="text-xl font-bold mb-4 text-black">
                Automated Disbursement
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Centralised verification and secure record keeping for all
                property documents
              </p>
            </div>
          </div>
        </div>

        {/* CTA Banner Section */}
        <div className="w-full">
          <div className="bg-[var(--nba-green)] rounded-[40px] p-16 md:p-24 text-center text-white relative overflow-hidden">
            <div className="relative z-10 max-w-4xl mx-auto flex flex-col items-center">
              <h2 className="text-4xl md:text-5xl font-bold mb-12 leading-tight">
                Redefine property transactions through
                <br />
                transparent standards
              </h2>
              <Link
                to="/signup"
                className="inline-flex items-center justify-center px-10 py-4 bg-black text-white font-bold rounded-xl hover:bg-gray-900 transition-colors text-lg"
              >
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
